
<!-- 产品展示页 -->
<template>
    <div class="content">
      <div class="toptitle box ac box_center">
        <div class="toptitleleft box ac">
          <img src="./images/ipylogo108.png" />
          <div class="box box_center box_v">
            <span>濮阳市一站式综合便民服务平台</span>
            <span>濮阳市一体化在线政务平台</span>
          </div>
        </div>
        <div class="toptitleright"><span>濮阳市政务服务和大数据管理局</span></div>
      </div>
      <div class="bannerbox box ac">
        <div class="loginbox">
          <div class="logtabbox box box_between">
            <div class="tablist box_v" @click="tabclick(0)"><span>二维码登录</span><span v-if="activeindex==0"></span></div>
            <div class="tablist box_v" @click="tabclick(1)"><span>账号登录</span><span v-if="activeindex==1"></span></div>
          </div>
          <div class="qrcodes" v-show="activeindex==0">
              <iframe style="width: 100%;height: 100%" :src="loginCodeUrl" frameborder="0" scrolling="no"  sandbox="allow-scripts allow-top-navigation  allow-same-origin"></iframe>
          </div>
          <div class="inputbox" v-show="activeindex==1">
            <div class="phonebox box ac">
              <div class="title">手机号</div>
              <input class="phoneinput" v-model="loginIfon.phoneNumber"  placeholder="请输入手机号" @blur="validatePhone" :class="{redborder:!isPhone && isvalidatePhone}" />
            </div>
            <p v-if="!isPhone && isvalidatePhone" style="color:#ff8a00;margin: 10px 0 10px 90px;">手机号不正确</p>
            <div class="phonebox box ac">
              <div class="title">验证码</div>
              <div class="codebox box ac">
                <input class="codeinput" type="text" placeholder="请输入密码" v-model="loginIfon.phoneCode" />
                <Button @click="getValidCode" v-if="isDisabled"  type="primary"  class="randomBtn box">发送验证码</Button>
                <Button v-else disabled class="randomBtn1 box">{{countdown}}s</Button>
              </div>
            </div>
            <div class="bottombtns box box_center">
              <Button type="primary" size="small" class="clickLogin bc-color" :loading="msg"  @click="send">
                <span v-if="!msg">登录</span>
                <span v-else>登录</span>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div class="servicebox">
        <div class="servicetitle"><span>特色服务</span></div>
        <div class="servicelistbox">
          <div class="servicelisttop box box_center">
            <div class="servicelist">
              <img class="servicelistimg" src="./images/18270545.png" />
              <div class="listinfobox">
                <div class="infotitle"><span>不动产</span></div>
                <div class="infotext box box_v">
                  <span>掌上交易、掌上办理=>居民少跑腿</span><span>数据留痕、交易审核=>工作更便捷</span><span>交易数据管理与统计=>情况全掌握</span>
                </div>
              </div>
            </div>
            <div class="servicelist">
              <img class="servicelistimg" src="./images/205012858.png" />
              <div class="listinfobox">
                <div class="infotitle"><span>新生入学</span></div>
                <div class="infotext1 box_v">
                  <div class="infotext1list box_v">
                    <span>家长报名：</span>
                    <span>所需材料在线提交、随时补充、操作简单、少跑腿</span>
                  </div>
                  <div class="infotext1list box_v">
                    <span>老师审核：</span>
                    <span>大数据智能校验、辅助决策报名情况实时掌握</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="servicelisttop box box_center">
            <div class="servicelist">
              <img class="servicelistimg" src="./images/shebaoka.png" />
              <div class="listinfobox">
                <div class="infotitle"><span>社保认证</span></div>
                <div class="infotext2 box box_v">
                  <span>帮助老年人解锁不跑腿、不排队</span><span>只需刷脸即可完成</span><span>线上社保资格认证</span>
                </div>
              </div>
            </div>
            <div class="servicelist">
              <img class="servicelistimg" src="./images/61873389.png" />
              <div class="listinfobox">
                <div class="infotitle"><span>高龄津贴</span></div>
                <div class="infotext1 box_v">
                  <div class="infotext1list box_v">
                    <span>老人申请：</span>
                    <span>支持老人家属代申请、审核进度实时查询</span>
                  </div>
                  <div class="infotext1list box_v">
                    <span>管理员审核：</span>
                    <span>大数据实名校验保障数据真实性</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="serviceUnits">
        <div class="serviceUnitstop"><span>服务单位</span></div>
        <div class="swiperbox">
          <Carousel v-model="selectIndex"
           :loop="setting.loop"
           :autoplay="setting.autoplay"
           :autoplay-speed="setting.autoplaySpeed"
           class="carousel_wrapper" id="carousel">
              <CarouselItem v-for="(item, index) in sliderlist" :key="index">
                  <div class="slideritem" :show="selectIndex==index?true:false">
                    <div class="topsliderbox box box_center">
                      <div v-for="(item, indexs) in item.itemlist" :key="indexs" :class="[baceClass,item.colorClass]">
                        <span>{{item.name}}</span>
                        <img :src="item.src" />
                      </div>
                    </div>
                    <div class="bottomsliderbox box box_center">
                      <div  v-for="(item, indexs1) in item.itemlist1" :key="indexs1" class="itemlist bgcolor0">
                        <span>{{item.name}}</span>
                        <img :src="item.src" />
                      </div>
                    </div>
                  </div>
              </CarouselItem>
          </Carousel>
        </div>
      </div>

      <div class="serviceArea">
        <div class="serviceAreatitle"><span>服务区县</span></div>
        <div class="arealistbox">
          <div class="arealist box ac box_center">
            <span>华龙区</span><span>清丰县</span><span>南乐县</span><span>范县</span><span>台前县</span>
          </div>
          <div class="arealist box ac box_center">
            <span>濮阳县</span><span>工业园区</span><span>开发区</span><span>示范区</span><span>中原油田</span>
          </div>
        </div>
      </div>

      <div class="footerbox box ac box_center">
        <div class="footerleft box_v">
          <span>主办单位：濮阳市人民政府办公室</span><span>地址：濮阳市人民路</span><span>邮编：476000</span><span>电话：0395-4546885</span>
        </div>
        <div class="footercenter box_v">
          <span>网站维护：濮阳市政务服务和大数据管理局</span><span>技术支持：北京北科互联城市治理技术研究院有限公司</span>
        </div>
        <div class="footerright box ac">
          <div class="qrcodebox box_v ac box_center">
            <img src="./images/ipyxiaochengxu.png" />
            <span>濮阳微信小程序</span>
          </div>
          <div class="qrcodebox box_v ac box_center">
            <img src="./images/ipyapp.png" />
            <span>濮阳安卓app</span>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import util from "../../utils/util";
import { mapActions } from "vuex";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {

    },
    props: ["msg"],
    data() {
    //这里存放数据
        return {
          baceClass:'itemlist',
          sliderlist:[
            {itemlist:[
                   {name:'濮阳人力资源和社会保障局',src:'https://shequyun.cn/onlinework/社保卡二.png',colorClass:'bgcolor0'},
                   {name:'濮阳市城市管理局',src:'https://shequyun.cn/onlinework/chengguan.png',colorClass:'bgcolor1'},
                   {name:'濮阳市卫生健康委',src:'https://shequyun.cn/onlinework/weisheng.png',colorClass:'bgcolor2'},
                   {name:'濮阳市住房公积金管理中心',src:'https://shequyun.cn/onlinework/公积金.png',colorClass:'bgcolor3'},
                ],
              itemlist1:[
                     {name:'濮阳市自然资源和规划局',src:'https://shequyun.cn/onlinework/自然资源和规划局.png',colorClass:'bgcolor4'},
                     {name:'濮阳市教育局',src:'https://shequyun.cn/onlinework/教育局.png',colorClass:'bgcolor5'},
                     {name:'濮阳市交通运输局',src:'https://shequyun.cn/onlinework/交通运输.png',colorClass:'bgcolor6'},
                     {name:'濮阳市医疗保障局',src:'https://shequyun.cn/onlinework/医疗.png',colorClass:'bgcolor7'},
                  ]
            },
            {
              itemlist:[
                     {name:'濮阳市公安局',src:'https://shequyun.cn/onlinework/公安局.png',colorClass:'bgcolor0'},
                     {name:'濮阳市住房和城乡建设局',src:'https://shequyun.cn/onlinework/建设局.png',colorClass:'bgcolor1'},
                     {name:'濮阳市通信发展管理办公室',src:'https://shequyun.cn/onlinework/tongxin_icon.png',colorClass:'bgcolor2'},
                     {name:'濮阳市发展和改革委员会',src:'https://shequyun.cn/onlinework/fgw_icon.png',colorClass:'bgcolor3'},
                  ],
                itemlist1:[
                   {name:'濮阳供电公司',src:'https://shequyun.cn/onlinework/供电局.png',colorClass:'bgcolor4'},
                   {name:'濮阳无线电管理局',src:'https://shequyun.cn/onlinework/wuxian_icon.png',colorClass:'bgcolor5'},
                   {name:'河南有线电视濮阳分公司',src:'https://shequyun.cn/onlinework/youxian_icon.png',colorClass:'bgcolor6'},
                   {name:'濮阳市档案局',src:'https://shequyun.cn/onlinework/dangan_icon.png',colorClass:'bgcolor7'},
                ]
            },
            {
              itemlist:[
                     {name:'濮阳市财政局',src:'https://shequyun.cn/onlinework/caizheng_icon.png',colorClass:'bgcolor0'},
                     {name:'濮阳市国家安全局',src:'https://shequyun.cn/onlinework/安全局.png',colorClass:'bgcolor1'},
                     {name:'濮阳市生态环境局',src:'https://shequyun.cn/onlinework/濮阳市生态环境局.png',colorClass:'bgcolor2'},
                     {name:'濮阳市司法局',src:'https://shequyun.cn/onlinework/濮阳市司法局.png',colorClass:'bgcolor3'},
                  ],
                itemlist1:[
                   {name:'濮阳市应急管理局',src:'https://shequyun.cn/onlinework/濮阳市应急管理局.png',colorClass:'bgcolor1'},
                   {name:'濮阳市残疾人联合会',src:'https://shequyun.cn/onlinework/濮阳市残疾人联合会.png',colorClass:'bgcolor5'},
                   {name:'濮阳市科学技术局',src:'https://shequyun.cn/onlinework/濮阳市科学技术局.png',colorClass:'bgcolor7'},
                   {name:'濮阳市金融工作局',src:'https://shequyun.cn/onlinework/濮阳市金融工作局.png',colorClass:'bgcolor6'},
                ]
            },
            {
              itemlist:[
                     {name:'濮阳市市场监督管理局',src:'https://shequyun.cn/onlinework/濮阳市市场监督管理局.png',colorClass:'bgcolor0'},
                     {name:'濮阳市邮政管理局',src:'https://shequyun.cn/onlinework/濮阳市邮政管理局.png',colorClass:'bgcolor1'},
                      {name:'濮阳人力资源和社会保障局',src:'https://shequyun.cn/onlinework/社保卡二.png',colorClass:'bgcolor0'},

                     {name:'濮阳市水利局',src:'https://shequyun.cn/onlinework/濮阳市水利局.png',colorClass:'bgcolor3'},
                  ],
                itemlist1:[
                   {name:'濮阳市烟草专卖局',src:'https://shequyun.cn/onlinework/濮阳市烟草专卖局.png',colorClass:'bgcolor4'},
                   {name:'濮阳市卫生健康委',src:'https://shequyun.cn/onlinework/weisheng.png',colorClass:'bgcolor2'},
                   {name:'濮阳市农业农村局',src:'https://shequyun.cn/onlinework/濮阳市农业农村局.png',colorClass:'bgcolor5'},
                   {name:'濮阳市商务局',src:'https://shequyun.cn/onlinework/濮阳市商务局.png',colorClass:'bgcolor2'},
                ]
            },
          ],
          setting: {
            autoplay: false,
            loop: true,
            autoplaySpeed:5000,
          },
          selectIndex:0,
          activeindex:0,
          loginCodeUrl: "",
          isYanfa: false, //判断是否是研发环境打开的
          aaa: "1111",
          loginTitle1: "二维码登录",
          loginTitle2: "账号登录",
          //      erweimaSrc:'https://open.weixin.qq.com/connect/qrcode/051eN8vgqTW8Bw8o',
          weixin: "微信",
          // 15501272356
          loginIfon: {
            phoneNumber: "",
            phoneCode: ""
          },
          isvalidatePhone: false,
          isPhone: false,
          isDisabled: true,
          countdown: 60,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      ...mapActions(["updateToken", "updateUid"]),
      tabclick(index){
        this.activeindex=index
      },
      validatePhone: function() {
        this.isvalidatePhone = true;
        // var reg = /^1[3|4|5|7|8][0-9]{9}$/;
        var reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
        this.isPhone = reg.test(this.loginIfon.phoneNumber);
      },
      getValidCode: function() {
        if (this.isPhone) {
          //if (this.slideFlag && this.isPhone) {
          this.isDisabled = false;

          this.$get(this.urlobj.sendRandomByPhone, {
            phone: this.loginIfon.phoneNumber
          })
            .then(resp => {
              this.setTime();
              console.log(resp);
            })
            .catch(error => {
              this.isDisabled = true;
              console.log(error);
            });
        } else {
          this.$Message.error("请填写正确的手机号!");
        }
      },
      setTime: function() {
        if (this.countdown == 0) {
          this.isDisabled = true;
          this.countdown = 60;
        } else {
          this.countdown--;
          var vm = this;
          setTimeout(function() {
            vm.setTime();
          }, 1000);
        }
      },
      send: function() {
        if (this.isPhone && this.loginIfon.phoneCode) {
          // this.$emit("event", this.loginIfon);
          this.handleSubmit(this.loginIfon);
        } else {
          this.$Message.error("请填写正确的手机号和验证码!");
        }
      },
      handleSubmit: function(name) {
        // 账号|account
        // logintype
        // 1、手机号验证码登录 2、邮箱验证码登陆
        // 3、手机号密码登陆 4、邮箱密码登陆 5、账号密码登陆
        //  密码|password
        // 验证码|code
        var vm = this;
        var url =
          this.urlobj.login +
          "?account=" +
          name.phoneNumber +
          "&code=" +
          name.phoneCode +
          "&logintype=1";
        this.$get(url)
          .then(resp => {
            vm.updateToken(resp.newPrimaryKeys.token);
            vm.updateUid(resp.newPrimaryKeys.uid);
            localStorage.setItem("uid",resp.newPrimaryKeys.uid)
            vm.checkManager()
          })
          .catch(error => {
            console.log(error);
          });
      },
      /* 检查用户登录信息 */
      checkManager: function() {
        var vm = this;
        var url = this.urlobj.checkManager;
        console.log(url);
        this.$get(url)
          .then(resp => {
            this.$store.commit('updateUserWorker',resp.newPrimaryKeys.userWorker)
            if (resp.newPrimaryKeys.resultStr == 0) {
              vm.$router.push("/register");
              if (!vm.$store.state.communityDetail) {
                vm.$store.state.communityDetail = {};
              }
            } else if (resp.newPrimaryKeys.resultStr == 1) {
              vm.$router.push("/auditPage");
            } else {

              vm.getSideBar().then(res => {
                vm.ismsg = true;


                // 正常跳转
                //判断是否为丛台区或濮阳市
                let path = resp.newPrimaryKeys.path.split('.')

                vm.$store.commit("updatePath", path);

                if(path.length>2 && path[2] == '410900000000'){
                  //濮阳市
                  vm.$store.commit("updateApptype", 'ipy');
                }else if(path.length>3 && path[3] == '130403000000'){
                  //丛台区
                  vm.$store.commit("updateApptype", 'ctt');
                }else if(path.length>3 && path[3] == '130423000000') {
                  //临漳
                  vm.$store.commit("updateApptype", 'lzt');
                } else if(path.length>=3 && path[3] == '361003000000') {
                  //东乡
                  vm.$store.commit("updateApptype", 'dxbst');
                }
                else{
                  vm.$store.commit("updateApptype", 'mst');
                }
                vm.$store.commit("updatelocation", resp.newPrimaryKeys.coordinate);
                /*
                10000007770004        国
                10000007770005        省/直辖市
                10000007770006        市/市辖区
                10000007770007        区/县
                10000007770008        街道/乡镇
                10000007770009        社区/村
                10000007770010        网格/组
                */
                if (resp.newPrimaryKeys.level == '10000007770009' || resp.newPrimaryKeys.level == '10000007770010' ){
                  console.log("社区/村 ||网格/组");
                  vm.$store.commit("updateIsJiedao", 0);
                }else{
                  //需要级联查询下级行政区域数据
                  vm.$store.commit("updateIsJiedao", 1);
                }
                vm.$store.commit(
                  "updateCommunityid",
                  resp.newPrimaryKeys.communityId
                );
                vm.$store.commit(
                  "updateheadpicurl",
                  resp.newPrimaryKeys.headPicUrl
                );
                vm.$store.commit(
                  "updateLevel",
                  resp.newPrimaryKeys.level
                );
                vm.$store.commit("updateUserName", resp.newPrimaryKeys.userName);

                if (vm.$store.state.isTV == 1) {
                  vm.getGongzhonghao();
                  vm.$store.commit("updateinitid", resp.newPrimaryKeys.initId);
                  vm.$router.push("/Shouye");
                } else if (resp.newPrimaryKeys.initId) {
                  vm.getGongzhonghao();
                  vm.$store.commit("updateinitid", resp.newPrimaryKeys.initId);
                  // vm.$store.commit("updateNavindex", 3);
                  this.$store.commit("updateChildrenInd", 0);
                  this.$store.commit("updateSideIndex", 0);
                  this.handleSidebarRoute()
                } else {
                  vm.$store.commit("updateGZHhead", "");
                  vm.$store.commit("updateGZHname", "");
                  vm.$store.commit("updateinitid", "");

                  // vm.$store.commit("updateNavindex", 99);
                  this.$store.commit("updateChildrenInd", 0);
                  this.$store.commit("updateSideIndex", 0);
                  this.handleSidebarRoute()
                }
              })
            }
          })
          .catch(error => {
            vm.$Notice.error({
              desc: error
            });
            vm.loading = false;
            console.log(error);
            vm.$router.push("/");
          });
      },
      handleSidebarRoute () {
        var name = '',sideBar = JSON.parse(this.$store.state.shequSideBar)

        sideBar = sideBar.filter(item => item.isShow)
        if ((sideBar[0].children))  {
          name = sideBar[0].children[0].router
          sideBar[0].showChild = 1
          this.$store.commit("updateShequSideBar", JSON.stringify(sideBar));
        }
        else name = sideBar[0].router
        this.$router.push({name});
      },
      getGongzhonghao() {
        var vm = this;
        var url = this.urlobj.get;

        this.$get(url).then(res => {
          var data = res.rows[0];
          if(res.rows.length){
             this.$store.commit("updateGZHhead", data.head_img);
             this.$store.commit("updateGZHname", data.gzhmingc);
          }else{
            this.$store.commit("updateGZHhead", "");
             this.$store.commit("updateGZHname","");
          }
          // if (data.head_img) {
          //   this.$store.commit("updateGZHhead", data.head_img);
          // } else {
          //   this.$store.commit("updateGZHhead", "");
          // }
          // this.$store.commit("updateGZHname", data.gzhmingc);
        });
      },
      codeRouter() {
        var vm = this;
        // 用正则 截取 code 和 state 值  可适用于 hash 路由 和 history 模式
        var code = util.getQueryString("code");
        var istv = util.getUrlKey("state");
        console.log(code);
        console.log(istv)
        if (code) {
          if (istv == 1) {
            this.$store.commit("updateIsTv", 1);
            this.$store.commit(
              "updateNavText",
              "弘扬民族文化，学习习近平讲话，建设美好社区"
            );
            document.getElementsByTagName("body")[0].style.zoom = 0.5;
          } else {
            this.$store.commit("updateIsTv", 0);
            this.$store.commit("updateNavText", "");
          }
          /* 二维码登录 */
          var url = this.urlobj.loginByQRcode;
          this.$get(url, {
            domain:window.location.host,
            code: code,
          })
            .then(function(response) {
              if (!vm.$store.state.userInfo) {
                vm.$store.state.userInfo = {};
              }
              vm.$store.commit("updateToken", response.newPrimaryKeys.token);
              vm.$store.commit("updateUid", response.newPrimaryKeys.uid);
              localStorage.setItem("uid",response.newPrimaryKeys.uid)
              vm.checkManager()
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      },
      getSideBar () {
        return new Promise((resolve, reject) => {
          var url = this.urlobj.getMiniSet;
          this.$get(url).then(res => {
            console.log(res)
            res.rows[0].pc.forEach(item => {
              if (item.moduleValue == "page_community_application") {
                //处理社区应用侧边菜单栏
                this.$store.commit("updateShequSideBar", JSON.stringify([]));
                let sideList = item.children?item.children.map(item => {
                  let sideItem = {
                    name:item.moduleName,
                    showChild:0,
                    isShow:item.isShow?true:false,
                    id:item.id,
                    subTitle:item.subTitle,
                    router:item.page
                  }
                  if (item.children && item.children.length) {
                    sideItem.children = item.children.map(item => {
                      return {
                        name:item.moduleName,
                        router:item.page,
                      }
                    })
                  }
                  return sideItem
                }):[]

                this.$store.commit("updateShequSideBar", JSON.stringify(sideList));
              }
              if (item.moduleValue == "page_community_management") {
                let isShowManage = this.$store.state.userWorker == '1'?item.isShow:0;
                //let isShowManage = 1
                // if(item.isShow && item.children.length){
                //   let social_worker = item.children.filter(_item=>_item.moduleValue == 'userSocialWorker');
                //   isShowManage = social_worker.length?social_worker[0].isShow:false;
                // }
                // item.isShow = isShowManage
                //处理社区应用侧边菜单栏

                let sideList = item.children?item.children.map(item => {
                  let sideItem = {
                    name:item.moduleName,
                    showChild:0,
                    isShow:isShowManage,
                    id:item.id,
                    subTitle:item.subTitle,
                    router:item.moduleValue
                  }
                  if (item.children && item.children.length) {
                    sideItem.children = item.children.map(item => {
                      return {
                        name:item.moduleName,
                        router:item.page,
                      }
                    })
                  }
                  return sideItem
                }):[]
                this.$store.commit("updateManagerList", sideList);
              }
            })

            //更新顶部导航栏选中
            let newNav = res.rows[0].pc.filter(item=>item.isShow)
            let navItems = []
            newNav.forEach(item => {
            if (item.moduleValue == "page_home") {
              navItems.push({
                text: item.moduleName,
                url: "/Shouye",
                type: "page_home"
              });
            } else if (item.moduleValue == "page_party") {
              navItems.push({
                text: item.moduleName,
                url: "/miniParty",
                type: "page_party"
              });
            } else if (item.moduleValue == "page_zone") {
              navItems.push({
                text: "微社区",
                url: "/miniCommunity",
                type: "page_zone"
              });
            } else if (item.moduleValue == "page_community_application") {
              navItems.push({
                text: item.moduleName,
                url: "/Shequ",
                type: "page_community_application"
              });
            } else if (item.moduleValue == "page_community_management") {
              let isShowManage = this.$store.state.userWorker == '1'?item.isShow:0;

              if(isShowManage){
                navItems.push({
                  text: item.moduleName,
                  url: "/userManager",
                  type: "page_community_management"
                });
             }

            }
          });
          this.$store.commit("updateNavigator", JSON.stringify(navItems));
            let newNavIndex = newNav.findIndex(item=>item.moduleValue == 'page_community_application');
            this.$store.commit("updateNavindex", newNavIndex>-1?newNavIndex:0);

            console.log(res.rows[0].pc)
            resolve()
          })
        });
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      //在登陆页面时清除sessionStorage
      sessionStorage.clear()
      var vm = this;
      var appid = "";
      var redirect_uri = "";
      let domain=window.location.host
      if (window.location.host.indexOf("localhost") > -1) {
        domain='ceshi.shequyun.cn'
      }
      /* 获取二维码 */
      this.$get(this.urlobj.getQrParam,{
        domain:domain
      })
      .then(resp => {
        appid = resp.newPrimaryKeys.appid;
        redirect_uri = encodeURIComponent(
          resp.newPrimaryKeys.serverUrl.replace("http://", "https://") + "/#/"
        );
        
        let href = "https://shequyun.cn/wx.css";
        vm.loginCodeUrl =
          "https://open.weixin.qq.com/connect/qrconnect?appid=" +
          appid +
          "&scope=snsapi_login&redirect_uri=" +
          redirect_uri +
          "&login_type=jssdk&self_redirect=default&href=" +
          href +
          "&state=2";
        if (this.$store.state.isTV == 1) {
          href = "https://shequyun.cn/wx_android.css";
          redirect_uri = encodeURIComponent(
            resp.newPrimaryKeys.serverUrl.replace("http://", "https://") + "/#/"
          );
          vm.loginCodeUrl =
            "https://open.weixin.qq.com/connect/qrconnect?appid=" +
            appid +
            "&scope=snsapi_login&redirect_uri=" +
            redirect_uri +
            "&login_type=jssdk&self_redirect=default&href=" +
            href +
            "&state=1";
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
     mounted() {
       console.log('mounted')
       // 如果返回值包含hash code 从其他应用打开 回调会触发
       if (util.getQueryString("code")) {
         this.codeRouter()
       }
       // document.onmouseup = function() {
       //   document.onmousemove = null;
       //   if (vm.ii >= 213) {
       //     vm.ii = 213;
       //   } else {
       //     vm.ii = 0;
       //   }
       // };
     },
     /* 从本页面返回code 直接更改hash会触发 */
     beforeRouteUpdate(to, from, next) {
       console.log("beforeRouteUpdate invoked");
       this.codeRouter()
       next();
     },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {

    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style scoped lang="less">
  .content{width: 100%;min-width: 1200px;background: #FFFFFF;overflow-y: scroll;cursor: default;}
  .toptitle{width: 100%;height: 120px;}
  .toptitleleft{height: 120px;}
  .toptitleleft img{width: 54px;height: 54px;border-radius: 10px;}
  .toptitleleft div{height: 120px;margin-left: 21px;}
  .toptitleleft div span:nth-child(1){font-size: 28px;font-weight: bold;color: #333333;}
  .toptitleleft div span:nth-child(2){font-size: 16px;font-weight: 400;color: #666666;margin-top: 10px;}
  .toptitleright{line-height: 120px;margin-left:25.2%;font-size: 18px;font-weight: 400;color: #666666;}

  .bannerbox{width: 100%;height: 608px;background-image: url('./images/banner.jpg');
    background-size:100% 608px;background-repeat: no-repeat;justify-content:flex-end;}
  .loginbox{width: 351px;height: 408px;background: #FFFFFF;margin-right:18.8%;position: relative;}
  .logtabbox{width: 100%;margin-top: 39px;}
  .tablist{width: 120px;cursor: pointer;}
  .tablist:nth-child(1){margin-left: 28px;}
  .tablist:nth-child(2){margin-right: 28px;}
  .tablist span:nth-child(1){height: 36px;line-height: 36px;text-align: center;font-weight: 400;color: #333333;font-size: 16px;}
  .tablist span:nth-child(2){width: 120px;height: 3px;background: #FF7C44;border-radius: 2px;}
  .qrcodes{width:351px;height:330px;margin-top:20px;}
  .inputbox{width:351px;height:330px;}
  .phonebox{width:100%;margin-top: 30px;}
  .title{width:90px;text-align: center;}
  .phonebox .phoneinput{width:230px;height:36px;line-height: 36px;border: 1px solid #d7dde4;border-radius: 5px;padding-left: 10px;}
  .redborder{border: 1px solid #ff8a00 !important;}
  .codebox{width: 230px;position: relative;height:36px;}
  .codeinput{width:230px;height:36px;line-height: 36px;border: 1px solid #d7dde4;border-radius: 5px;padding-left: 10px;}
  .codebox .randomBtn{width: 105px;height: 36px;border: 1px solid #d7dde4;border-radius: 5px;line-height:36px;
      color: #FFFFFF;cursor: pointer;position: absolute;top: 0;right: 0;}
  .randomBtn1{width: 105px;height: 36px;background: none;outline: none;border: 1px solid #d7dde4;
    border-radius: 5px;line-height:36px;color: #575656;cursor: pointer;position: absolute;top: 0;right: 0;}
  .bottombtns{width: 100%;position: absolute;bottom: 30px;}
  .clickLogin {
      width: 80%;
      height: 40px;
      outline: none;
      border: none;
      border-radius: 5px;
      margin: 0 auto;
      color: #fff;
      cursor: pointer;
    }

  .servicebox{width: 100%;padding-bottom: 60px;}
  .servicetitle{width: 100%;height: 148px;text-align: center;line-height: 148px;font-size: 30px;font-weight: bold;color: #333333;}
  .servicelistbox{width: 100%;}
  .servicelisttop{width: 100%;margin-top: 65px;}
  .servicelisttop:nth-child(1){margin-top: 0;}
  .servicelist{width: 500px;height: 370px;position: relative;}
  .servicelist:nth-child(2){margin-left: 10.416%;}
  .servicelistimg{width: 500px;height: 240px;}
  .listinfobox{width:460px;height:195px;position: absolute;bottom: 0;left: 20px;background: #FFFFFF;
     box-shadow: 0px 0px 21px 0px rgba(52, 78, 108, 0.35);border-radius: 20px;}
  .infotitle{width: 100%;height: 79px;line-height: 79px;font-weight: bold;font-size: 20px;color: #333333;text-align: center;}
  .infotext{width: 100%;margin-top: -7px;}
  .infotext span{height: 30px;font-size: 16px;font-weight: 400;color: #666666;line-height: 30px;width: 100%;text-align: center;}
  .infotext1{width: 100%;margin-top: -11px;}
  .infotext1list{margin-left: 72px;margin-top: 19px;}
  .infotext1list span{font-size: 16px;font-weight: 400;color: #666666;line-height:18px;}
  .infotext1list:nth-child(1){margin-top: 0;}
  .infotext2{margin-top: -7px;font-size: 16px;font-weight: 400;color: #666666;line-height: 30px;}
  .infotext2 span{margin-left:62px;}

  .serviceUnits{width: 100%;height: 443px;background: #F1F1F1;}
  .serviceUnitstop{width: 100%;height: 149px;line-height: 149px;font-weight: bold;font-size: 30px;color: #333333;text-align: center;}
  .swiperbox{width: 100%;height: 232px;}
  .carousel_wrapper{width: 100%;height: 232px;}
  .slideritem{width: 100%;height: 190px;}
  .topsliderbox{width: 100%;height: 80px;}
  .bottomsliderbox{width: 100%;height: 80px;margin-top: 30px;}
  .itemlist{width: 285px;height: 79px;position: relative;border-radius: 5px;margin-right: 20px;}

  .bgcolor0{background: linear-gradient(105deg, #FFFFFF 0%, #EFF9FF 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor1{background: linear-gradient(105deg, #FFFFFF 0%, #FFFAF1 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor2{background: linear-gradient(105deg, #FFFFFF 0%, #F0F9FF 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor3{background: linear-gradient(105deg, #FFFFFF 0%, #FAFFF4 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor4{background: linear-gradient(105deg, #FFFFFF 0%, #FBFFF5 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor5{background: linear-gradient(105deg, #FFFFFF 0%, #F1F9FF 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor6{background: linear-gradient(105deg, #FFFFFF 0%, #FBFFF5 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .bgcolor7{background: linear-gradient(105deg, #FFFFFF 0%, #FFF5EF 100%);box-shadow: 0px 0px 21px 0px rgba(207, 207, 207, 0.35);}
  .itemlist span{width: 285px;height: 79px;line-height: 79px;text-align: center;display: block;font-size: 18px;font-weight: 400;color: #666666;
     position: absolute;z-index: 2;top: 0;left: 0;}
  .itemlist img{height:auto;position: absolute;right:-4px;top: 50%;transform: translate(0,-50%);z-index: 1;opacity: 0.2;}

  .serviceArea{width:100%;height: 390px;}
  .serviceAreatitle{width: 100%;height: 148px;line-height: 149px;font-weight: bold;font-size: 30px;color: #333333;text-align: center;}
  .arealistbox{width: 100%;}
  .arealist{width: 100%;margin-top: 25px;}
  .arealist:nth-child(1){margin-top: 0;}
  .arealist span{width: 220px;height: 50px;border:dashed 1px RGBA(255, 124, 68, 1);text-align: center;line-height: 50px;border-radius: 5px;margin-left: 25px;
      font-size: 18px;font-weight: 400;color:RGBA(255, 124, 68, 1);}
  .arealist span:nth-child(1){margin-left: 0;}

  .footerbox{width: 100%;height: 240px;background: #434343;}
  .footerleft{height: 240px;}
  .footerleft span{font-size: 14px;font-weight: 400;color: #BDBDBD;line-height: 28px;}
  .footerleft span:nth-child(1){margin-top: 64.5px;}
  .footercenter{height: 240px;margin-left: 10.677%;}
  .footercenter span{font-size: 14px;font-weight: 400;color: #BDBDBD;line-height: 28px;}
  .footercenter span:nth-child(1){margin-top: 64.5px;}
  .footerright{height: 240px;margin-left: 9.27%;}
  .qrcodebox{width: 106px;height: 240px;margin-left: 60px;}
  .qrcodebox:nth-child(1){margin-left: 0;}
  .qrcodebox img{width: 106px;height: 106px;}
  .qrcodebox span{font-size: 14px;font-weight: 400;color: #BDBDBD;margin-top:20px;}
</style>
